export const INIT = 'menu-configurator.init';
export const SELECT_ITEM = 'menu-configurator.select-item';
export const SELECT_TAB = 'menu-configurator.select-tab';
export const FINISH_CONFIGURATION = 'menu-configurator.finish';

export function init(state) {
    return {type: INIT, payload: state};
}

export function selectItem(item) {
    return {type: SELECT_ITEM, payload: item};
}

export function selectTab(tab) {
    return {type: SELECT_TAB, payload: tab};
}

export function finishConfiguration() {
    return {type: FINISH_CONFIGURATION};
}
